import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { divisionActions } from '@app/store/division/actions/division.actions';
import { divisionsActions } from '../actions/divisions.actions';
import { selectValue } from '../selectors/divisions.selector';

@Injectable()
export class DivisionsDivisionBridge {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);

    reloadAfterDelete$ = createEffect(() => {
        return this.actions.pipe(
            ofType(divisionActions.deleteDivisionSuccess),
            concatLatestFrom(() => this.store.select(selectValue)),
            map(([, value]) => divisionsActions.getDivisions({ value })),
        );
    });
}
